import { render, staticRenderFns } from "./NavbarComponent.vue?vue&type=template&id=6a20a820&scoped=true&"
import script from "./NavbarComponent.vue?vue&type=script&lang=js&"
export * from "./NavbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./NavbarComponent.vue?vue&type=style&index=0&id=6a20a820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a20a820",
  null
  
)

export default component.exports